import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const cache = new Map();

async function loadSketch(params) {
  const key = JSON.stringify(params);
  if (!cache.has(key)) {
    const p = api.get("/sketch", { params, responseType: "text" })
      .then((r) => `data:image/svg+xml;charset=utf-8,${encodeURIComponent(r.data)}`)
      .catch((e) => { cache.delete(key); throw e; });
    cache.set(key, p);
  }
  return cache.get(key);
}

// Line drawing rendered by the same backend code that draws the PDF.
export function LineSketch({ params, boxW = 180, boxH = 200, className = "", testId }) {
  const [src, setSrc] = useState(null);
  const key = JSON.stringify(params);
  useEffect(() => {
    let alive = true;
    const t = setTimeout(() => {
      loadSketch({ ...JSON.parse(key), box_w: boxW, box_h: boxH }).then((s) => alive && setSrc(s)).catch(() => {});
    }, 250);
    return () => { alive = false; clearTimeout(t); };
  }, [key, boxW, boxH]);
  return (
    <div data-testid={testId} className={`grid place-items-center rounded-md bg-white ${className}`}>
      {src ? <img src={src} alt="Line drawing" className="h-full w-full object-contain" /> : <div className="h-1/2 w-1/2 animate-pulse rounded bg-slate-200" />}
    </div>
  );
}
